class HotjarTracker {
  execute (method, ...params) {
    if (typeof hj === 'undefined') {
      console.info('Hotjar is not initialized.')
      return
    }
    return hj(method, ...params)
  }

  trigger = (name) => {
    this.execute('trigger', name)
  }
}

export default HotjarTracker



// WEBPACK FOOTER //
// ./src/common/general/js/HotjarTracker.js